import { render } from "./NapTemplateList.vue?vue&type=template&id=57270688&ts=true"
import script from "./NapTemplateList.vue?vue&type=script&lang=ts"
export * from "./NapTemplateList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__